// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1s8Cy","choiceBoxes":"toolbarselects_choiceBoxes__3b7yS","simpleField":"toolbarselects_simpleField__3z3Bp"};